// extracted by mini-css-extract-plugin
export default {"text":"RestoreTrashbinFilesThanksModal__text--Svmtd"};